export default __webpack_public_path__ + "static/media/cierra.5762aa33.jpg";